// Texte des Filter-Editors und des Speicherns (Agent 5A, Runde 5). Eingeführte Begriffe bleiben (Lead, Smart View, Opportunity),
// alles andere kurz und sachlich auf Deutsch. Eigene Datei, damit `texte.ts` (gemeinsam) unberührt bleibt.
/** Satz für ein verwandtes Objekt: „Hat eine Opportunity, bei der“, „Hat keinen Kontakt, bei dem“, „Gehört zu einem Lead, bei dem“. */
export function verwandtSatz(label: string, negate: boolean): string {
  if (label === "Kontakt") return negate ? "Hat keinen Kontakt, bei dem" : "Hat einen Kontakt, bei dem";
  if (label === "Lead") return negate ? "Gehört zu keinem Lead, bei dem" : "Gehört zu einem Lead, bei dem";
  return negate ? `Hat keine ${label}, bei der` : `Hat eine ${label}, bei der`;
}

export const FILTER_TEXTE = {
  filter: "Filter",
  filterHinzufuegen: "Filter hinzufügen",
  gruppeHinzufuegen: "Gruppe hinzufügen",
  gruppeEntfernen: "Gruppe entfernen",
  bedingungEntfernen: "Bedingung entfernen",
  findeLeads: "Finde Leads, auf die zutrifft:",
  findeAndere: (objekt: string) => `Finde ${objekt}, auf die zutrifft:`,
  einklappen: "Filter einklappen",
  ausklappen: "Filter ausklappen",
  nichtGespeichert: "Nicht gespeichert",
  verwerfen: "Verwerfen",
  verwerfenTitel: "Änderungen am Filter verwerfen",
  feldSuchen: "Feld suchen …",
  feldWaehlen: "Feld für den Filter wählen",
  keinFeld: "Kein passendes Feld.",
  nichtMoeglich: "noch nicht möglich",
  verwandteObjekte: "Verknüpfte Objekte",
  /** „Hat eine Opportunity, bei der …“ (Auswahl im Feldmenü) */
  hatVerwandt: (label: string) => verwandtSatz(label, false) + " …",
  verwandtSatz: (label: string, negate: boolean) => verwandtSatz(label, negate),
  fertig: "Fertig",
  entfernen: "Entfernen",
  unvollstaendig: "Noch kein Wert gewählt: der Filter gilt erst, wenn er ausgefüllt ist.",
  unbekannteBedingung: "Diese Bedingung stammt aus Close und lässt sich hier nicht bearbeiten. Sie bleibt unverändert erhalten.",
  unbekannterKnoten: "Unbekannte Bedingung",
  katalogFehlt: "Die Felder konnten nicht geladen werden. Die Bedingungen sind nur lesbar.",
  zeitpunktWaehlen: "Zeitpunkt wählen",
  umkehren: "Bedingung umkehren (nicht)",
  istEiner: "ist",
  istNicht: "ist nicht",
  istGesetzt: "ist gesetzt",
  istLeer: "ist leer",
  suchen: "Suchen …",
  keineOptionen: "Keine Auswahl vorhanden.",
  werteEintragen: "Wert eintippen, Enter fügt hinzu",
  grenze: { ab: "Ab", bis: "Bis" },
  zeitart: { periode: "Zeitraum", versatz: "Abstand", datum: "Datum", jetzt: "Jetzt" },
  beginn: "Beginn",
  ende: "Ende",
  vor: "vor",
  in: "in",
  zahl: "Wert",
  einheit: { sek: "Sekunden", min: "Minuten", std: "Stunden", tage: "Tage" },
  json: {
    kopieren: "Filter kopieren (JSON)",
    einfuegen: "Filter aus Zwischenablage einfügen",
    kopiert: "Filter als JSON kopiert.",
    kopierenFehler: "Kopieren hat nicht geklappt.",
    einfuegenFehler: "In der Zwischenablage steht kein gültiger Filter.",
    eingefuegt: "Filter eingefügt. Speichern übernimmt ihn.",
    alleEntfernen: "Alle Filter entfernen",
  },
  speichern: {
    speichern: "Speichern",
    speichernTitel: "Änderungen an dieser Smart View speichern",
    nichtsGeaendert: "Noch nichts geändert",
    speichernUnter: "Speichern unter …",
    speichernUnterKnopf: "Speichern unter",
    speichernUnterTitel: "Als neue Smart View speichern",
    keinRecht: "Diese Smart View gehört jemand anderem. Mit „Speichern unter“ lässt sich eine eigene Kopie anlegen.",
    gespeichert: "Smart View gespeichert.",
    gespeichertKopie: "Gespeichert. Die Smart View gilt ab jetzt im CRM, Close bleibt unverändert.",
    angelegt: "Smart View angelegt.",
    bearbeiten: "Smart View bearbeiten",
    bearbeitenKlein: "Name, Emoji und Freigabe ändern",
    loeschen: "Smart View löschen",
    loeschenFrage: "Wirklich löschen?",
    geloescht: "Smart View gelöscht.",
    geloeschtClose: "Smart View gelöscht. In Close bleibt sie bestehen, im CRM ist sie weg.",
    name: "Name",
    namePlatzhalter: "z. B. Follow-up heute",
    emoji: "Emoji",
    emojiKein: "Kein Emoji",
    teilen: "Mit dem Team teilen",
    teilenHinweis: "Alle im Team sehen und nutzen die Smart View. Teilen dürfen nur Nutzer mit dem Recht für Team-Smart-Views.",
    teilenKeinRecht: "Dafür fehlt das Recht für Team-Smart-Views.",
    abbrechen: "Abbrechen",
    closeHinweis: "Diese Smart View kommt aus Close. Änderungen gelten ab jetzt nur im CRM, die Fassung in Close bleibt unverändert.",
    nameFehlt: "Bitte einen Namen eingeben.",
    ersatzHinweis: "Die Smart View ist aus Close übernommen; die Fassung hier im CRM ersetzt sie für alle, die sie sehen.",
  },
} as const;
